<template>
  <div class="m-activity-prizesAdvancedSet">
    <el-form-item label="奖品每人可中" prop="userTotalLimit">
      <el-input v-model="form.userTotalLimit" placeholder="请输入次数" oninput="value=value.replace(/[^\d]/g,'')" >
        <template slot="append">次</template>
      </el-input>
    </el-form-item>
    <el-form-item label="是否开启高级设置" prop="advanceControl" v-if="baseInfo.scene !== 'SupplierAfterPay'">
      <el-radio-group v-model="form.advanceControl" >
        <el-radio :label="false">否</el-radio>
        <el-radio :label="true">是</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="(form.id || form.isEdit) && form.advanceControl" prop="userWhitelist" label="白名单会员">
      <select-member :form="form" name="userWhitelist" :selected="form.userWhiteSelected" @change="onMemberChange" />
    </el-form-item>
    <div v-if="form.advanceControl" class="winning-ctrl">
      <el-form-item prop="mallIds" label="选择商场">
        <el-select v-model="form.mallIds" placeholder="请选择商场" @change="onMallChange" multiple collapse-tags filterable clearable >
          <el-option v-for="item in applyMallData" :key="item.mallId" :label="item.mallName" :value="item.mallId"></el-option>
        </el-select>
      </el-form-item>
      <div class="mall-table-box" v-if="form.mallIds && form.mallIds.length">
        <div class="default-box">
          <el-form-item label="默认时间" label-width="80px">
            <el-date-picker
              type="datetimerange"
              range-separator=""
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              v-model="defaultDate"
            />
          </el-form-item>
          <el-button type="primary" @click="setDefaultDate" class="ml10 mr20">批量设置</el-button>
          <el-form-item label="默认数量" label-width="80px">
            <el-input placeholder="" v-model="defaultAmount" clearable oninput="value=value.replace(/[^\d]/g,'')" />
          </el-form-item>
          <el-button type="primary" @click="setDefaultAmount" class="ml10">批量设置</el-button>
          <div class="hint">（点击“批量设置”按钮，投放时间和投放数量会批量更改）</div>
        </div>
        <div class="table-box">
          <el-table
            :data="mallTableList"
            style="width: 100%"
            empty-text="暂无数据"
            :header-cell-style="{ background:'#F2F3F5',height:'50px',border: '0'}"
            :row-key="row => row.mallId"
            ref="table"
          >
            <el-table-column prop="mallName" label="商场名称" width="200"></el-table-column>
            <el-table-column prop="time" label="投放时间">
              <template slot-scope="scope" >
                <div v-if="scope.row.deployTimeList && scope.row.deployTimeList.length">
                  <el-tooltip class="tooltip" placement="right" effect="light">
                    <div class="date-box">
                      <span>{{$moment(scope.row.deployTimeList[0].start).format('YYYY/MM/DD HH:mm:ss')}}</span>
                      <span>—</span>
                      <span>{{$moment(scope.row.deployTimeList[0].end).format('YYYY/MM/DD HH:mm:ss')}}</span>
                    </div>
                    <div slot="content">
                      <div v-for="(item, index) in scope.row.deployTimeList" :key="index">
                        <span>{{$moment(item.start).format('YYYY/MM/DD HH:mm:ss')}}</span>
                        <span>—</span>
                        <span>{{$moment(item.end).format('YYYY/MM/DD HH:mm:ss')}}</span>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
                <span v-else>---</span>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="投放数量">
              <template slot-scope="scope" >
                <el-form-item label-width="0" prop="deployLimit" :rules="[{validator: (r, v, c) => checkDeployLimit(r, v, c, scope)}]" >
                  <el-input v-model="mallTableList[scope.$index].deployLimit" placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="operation" label="操作">
              <template slot-scope="scope" >
                <el-button type="text" @click="onSetDeployTime(scope.row)" class="mr10">设置投放时间</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </div>
      </div>
    </div>
    <prizes-deploy-time-set
      :show="deployTimeDialog"
      :row="currentRow"
      @close="onCloseDeployTimeDialog"
      @confirm="onDeployTimeConfirm"
    />
  </div>
</template>

<script>
import prizesDeployTimeSet from './prizesDeployTimeSet.vue'
import SelectMember from '@/components/SelectMember'

export default {
  name: "marketActivityListPrizesAdvancedSet",
  components: {
    prizesDeployTimeSet,
    SelectMember,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    baseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    prizesItem: {
      type: Object,
      default() {
        return {}
      }
    },
    mallData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    // 校验表格中的输入框
    const checkDeployLimit = (rule, v, callback, scope) => {
      const value = this.mallTableList[scope.$index].deployLimit
      if (!value) {
        callback(new Error('请输入'))
      } else {
        callback()
      }
    }

    return {
      applyMallData: [], // 参与限制所选适用商场数据
      prizeMallDeployList: [], // 选择投放的商场
      mallTableList: [], // 商场列表分页渲染数据
      total: 0,
      currentPage: 1,
      offset: 0,
      limit: 10,
      defaultDate: null,
      defaultAmount: null,
      deployTimeDialog: false,
      currentRow: null,
      checkDeployLimit
    };
  },
  async created() {
    this.getApplyMallData() // 获取适用商场数据
  },
  methods: {
    // 获取适用商场数据
    getApplyMallData() {
      let arr = []
      if (this.baseInfo.useRange == 'Generic') {
        arr = [...this.mallData]
      } else {
        arr = this.mallData.filter(item => this.baseInfo.mallIds.indexOf(item.id) >= 0)
      }
      this.applyMallData = arr.map(item => {
        return {
          mallId: item.id,
          mallName: item.name
        }
      })
    },

    // 编辑时回显数据
    getEditDetail(list=[]) {
      this.prizeMallDeployList = list
      this.total = list.length
      this.getMallTableList()
      console.log(this.form);
    },

    // 选择商场下拉框改变
    onMallChange(value) {
      if (!value.length) {
        this.prizeMallDeployList = [] // 清空
      } else if (value.length > this.prizeMallDeployList.length) {
        const current = this.applyMallData.find(item => item.mallId == value[value.length - 1])
        this.prizeMallDeployList.push(current)
      } else {
        const current = this.prizeMallDeployList.findIndex(item => value.indexOf(item.mallId) == -1)
        delete this.prizeMallDeployList[current].deployLimit
        this.prizeMallDeployList.splice(current, 1)
      }
      this.total = this.prizeMallDeployList.length
      this.getMallTableList()
    },

    // 获取商场表格渲染数据
    getMallTableList() {
      this.mallTableList = [...this.prizeMallDeployList].splice(this.offset, this.limit)
    },

    // 批量设置默认时间
    setDefaultDate() {
      this.prizeMallDeployList = this.prizeMallDeployList.map(item => {
        return {
          ...item,
          deployTimeList: this.defaultDate ? [
            {
              start: this.defaultDate[0],
              end: this.defaultDate[1],
            }
          ] : []
        }
      })
      this.getMallTableList()
    },

    // 批量设置默认数量
    setDefaultAmount() {
      this.prizeMallDeployList = this.prizeMallDeployList.map(item => {
        return {...item, deployLimit: this.defaultAmount}
      })
      this.getMallTableList()
    },

    // 点击设置投放时间按钮
    onSetDeployTime(row) {
      this.currentRow = row
      this.deployTimeDialog = true
    },

    // 投放时间确定
    onDeployTimeConfirm(value) {
      let index = this.prizeMallDeployList.findIndex(item => item.mallId == this.currentRow.mallId)
      this.prizeMallDeployList.splice(index, 1, {
        ...this.currentRow,
        deployTimeList: value
      })
      this.getMallTableList()
      this.onCloseDeployTimeDialog()
    },

    // 关闭投放时间设置弹窗
    onCloseDeployTimeDialog() {
      this.currentRow = null
      this.deployTimeDialog = false
    },

    // 白名单会员改变
    onMemberChange(value) {
      this.$emit('onMemberChange', value)
    },

    handleSizeChange (limit) {
      this.limit = limit
      this.getMallTableList()
    },

    handleCurrentChange (val) {
      this.offset = (val - 1) * this.limit
      this.getMallTableList()
    },
  },
  watch: {

  }
};
</script>

<style lang="scss" scoped>
.m-activity-prizesAdvancedSet {
  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .mall-table-box {
    margin-left: 140px;
    border: 1px solid #ccc;
    padding: 20px;
    padding-bottom: 0;
    border-radius: 4px;

    .default-box {
      display: flex;
      justify-content: flex-start;
      overflow: hidden;
      // overflow-x: scroll;
      flex-wrap: wrap;

      .el-input {
        width: 250px;
      }
      .el-date-editor {
        width: 250px;
      }
      .el-button {
        min-width: 80px;
      }
      .hint {
        flex-shrink: 0;
        height: 34px;
        line-height: 34px;
        margin-left: 20px;
        color: #999;
      }
    }

    .table-box {
      .date-box {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .el-pagination {
        margin: 20px 0;
      }
    }
  }

}
</style>
